import {ROLES} from "../../../utils/constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface RoleBadgeProps {
  roleValue: string;
}

export const RoleBadge = ({ roleValue }: RoleBadgeProps) => {
  const role = ROLES.find((r) => r.value === roleValue);
  if (!role) return null; // Return nothing if the role is not found
  return (
    <div
      key={role.value}
      className={`flex flex-row items-center px-4 py-1 rounded-lg gap-x-2 w-fit ${role.bgGradient}`}
    >
      {role.icon && <FontAwesomeIcon icon={role.icon} className="text-sm"/> }
      <span className="text-sm">
        {role.label}
      </span>
    </div>
  );
};
